/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 取消王府井的支付订单
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class CancelPayOrderParams {
  constructor(public billNo?: string) {}
}

export default async function (
  params: CancelPayOrderParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/cancel/pay-order`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
